/* eslint-disable @typescript-eslint/naming-convention */
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import Select from '@material-ui/core/Select'
import Theme from '@material-ui/core/styles/MuiThemeProvider'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import React, {
  FormEvent,
  Fragment,
  useContext,
  useEffect,
  useState,
} from 'react'
import { HiOutlineBriefcase } from 'react-icons/hi2'
import { RiBuilding4Line } from 'react-icons/ri'
import { TbUser } from 'react-icons/tb'

import {
  DependenteInfo,
  SchedulerStepContext,
} from '../../Context/ShedulerStepContext'
import { buscarCNPJ, getDependentes } from '../../services/agendamento'
import { UserData } from '../../services/user'
import cnpjMask, { removeCnpjMask } from '../../utils/cnpjFormat'
import getCookie from '../../utils/getCookies'
import AlertCard from './components/AlertCard'
import RegisterDependentForm from './RegisterDependentForm'
interface IdentificationOptionCheckProps {
  profile: 'Cidadão' | 'Empresa' | 'Servidor'
  listOptions: Array<'Cidadão' | 'Empresa' | 'Servidor'>
  cnpjNumber: string
  companyCountry: string | null
  onCompanyCountry: (value: string) => void
  controlRadio: (value: 'Cidadão' | 'Empresa' | 'Servidor') => void
  handleChangeValueCnpj: (value: FormEvent) => void
  onRegisterFormVisibilityChange?: (isVisible: boolean) => void
  hasDependente?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    width: '100%',
    maxWidth: 536,
    gap: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 72,
    justifyContent: 'center',
    border: '1px solid #DAE1EF',
    borderRadius: 4,
    cursor: 'pointer',
    [theme.breakpoints.down(660)]: {
      padding: '20px 20px 28px 20px',
    },
  },
  cardChecked: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  radioChecked: {
    color: theme.palette.primary.main,
  },
  radioInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  cardHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px',
  },
  cardSelectArea: {
    marginLeft: 16,
  },
  containerSelectCitizen: {
    width: '100%',
    padding: '8px 24px 16px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    [theme.breakpoints.down(660)]: {
      padding: '16px 0 0 0',
    },
  },
  selectLabel: {
    color: '#374151',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    marginBottom: 4,
  },
  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 6,
    },
    '& .MuiSelect-select': {
      padding: '12px 14px',
    },
  },
  icon: {
    width: 24,
    height: 24,
    color: '#6B7280',
    [theme.breakpoints.down(660)]: {
      width: 24,
      height: 24,
    },
  },
  iconChecked: {
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500,
    display: 'block',
    [theme.breakpoints.down(660)]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  containerInfoEmployer: {
    width: '100%',
    padding: '8px 24px 10px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  containerLoading: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  identificationHeader: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    textAlign: 'left',
    width: '100%',
  },
  registerDependentText: {
    fontSize: theme.typography.pxToRem(14),
    color: '#6B7280',
    marginTop: 8,
  },
  clickableText: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}))

export default function IdentificationOptionCheck({
  profile,
  listOptions,
  cnpjNumber,
  companyCountry,
  onCompanyCountry,
  controlRadio,
  handleChangeValueCnpj,
  onRegisterFormVisibilityChange,
  hasDependente,
}: IdentificationOptionCheckProps): JSX.Element {
  const {
    handleSelectDependente,
    onChangeCompanyName,
    onChangeCompanyAddress,
  } = useContext(SchedulerStepContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [sefazError, setSefazError] = useState<string | null>(null)
  const [companyAddress, setCompanyAddress] = useState<string | null>(null)
  const [companyName, setCompanyName] = useState<string | null>(null)
  const [showCitizenSelect, setShowCitizenSelect] = useState<boolean>(false)
  const [dependentes, setDependentes] = useState<DependenteInfo[]>([])
  const [loadingDependentes, setLoadingDependentes] = useState<boolean>(false)
  const [selectedValue, setSelectedValue] = useState<string>('para-mim')
  const [showRegisterForm, setShowRegisterForm] = useState<boolean>(false)

  const handleResetValues = () => {
    setCompanyAddress(null)
    onCompanyCountry(null)
    setCompanyName(null)
    onChangeCompanyName?.(null)
    onChangeCompanyAddress?.(null)
    setSefazError(null)
  }

  const handleCancelRegister = () => {
    setShowRegisterForm(false)
    onRegisterFormVisibilityChange?.(false)
  }

  const handleSuccessRegister = () => {
    fetchDependentes()
    setShowRegisterForm(false)
    onRegisterFormVisibilityChange?.(false)
  }

  const fetchDependentes = async () => {
    try {
      setLoadingDependentes(true)
      const token: string | null = getCookie('gov_access_token_sso')
      const userDataString: string | null = getCookie('gov_user_data')
      const userData: UserData | null = userDataString
        ? JSON.parse(userDataString)
        : null

      if (token && userData?.cpf) {
        const response = await getDependentes(token, userData.cpf)
        setDependentes(response.data || [])
      }
    } catch (error) {
      console.log('Erro ao buscar dependentes:', error)
      setDependentes([])
    } finally {
      setLoadingDependentes(false)
    }
  }

  const handleSelectChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string

    if (hasDependente) {
      setSelectedValue('para-mim')
      handleSelectDependente?.(null)
      return
    }

    setSelectedValue(value)

    if (value === 'para-mim') {
      handleSelectDependente?.(null)
    } else {
      // value é o ID do dependente
      const dependente = dependentes.find((dep) => dep.id.toString() === value)
      if (dependente) {
        handleSelectDependente?.(dependente)
      }
    }
  }

  useEffect(() => {
    if (
      showCitizenSelect &&
      (profile === 'Cidadão' || profile === 'Servidor')
    ) {
      fetchDependentes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCitizenSelect, profile])

  useEffect(() => {
    // Quando há apenas uma opção e ela é pré-selecionada, mostrar o select automaticamente
    if (
      listOptions.length === 1 &&
      (profile === 'Cidadão' || profile === 'Servidor')
    ) {
      setShowCitizenSelect(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, listOptions])

  const getDataCompany = async () => {
    if (!cnpjNumber) return
    const cnpjWithoutMask = removeCnpjMask(cnpjNumber)
    if (cnpjWithoutMask.length !== 14) return
    try {
      setLoading(true)
      setSefazError(null)
      const { data } = await buscarCNPJ(cnpjWithoutMask)

      if (data?.dados_sefaz) {
        const { dados_sefaz } = data
        const nomeEmpresa = dados_sefaz.NomeEmpresarial
        const enderecoEmpresa = `${dados_sefaz.Logradouro}, ${dados_sefaz.NumeroLogradouro} - ${dados_sefaz.CEP}`

        setCompanyName(nomeEmpresa)
        setCompanyAddress(enderecoEmpresa)
        onCompanyCountry(dados_sefaz.NomeMunicipio)

        // Salvar no contexto
        onChangeCompanyName?.(nomeEmpresa)
        onChangeCompanyAddress?.(enderecoEmpresa)
      } else {
        setSefazError(
          'Não foi possível consultar os dados da empresa. Verifique o CNPJ e tente novamente.',
        )
      }
    } catch (error) {
      console.log(error)
      setSefazError(
        'Não foi possível consultar os dados da empresa no momento. Tente novamente em instantes.',
      )
    } finally {
      setLoading(false)
    }
  }

  const isAlertVisible =
    profile === 'Empresa' &&
    typeof companyCountry === 'string' &&
    companyCountry !== 'SALVADOR'

  const classes = useStyles()

  return (
    <>
      {showRegisterForm ? (
        <RegisterDependentForm
          onCancel={handleCancelRegister}
          onSuccess={handleSuccessRegister}
        />
      ) : (
        listOptions.length &&
        listOptions.map((list) => {
          if (list === 'Cidadão') {
            return (
              <Box key={list} id="citizen-profile" className={classes.item}>
                <span className={classes.identificationHeader}>
                  Selecione o perfil para realizar o agendamento
                </span>
                <Box
                  className={`${
                    profile === 'Cidadão'
                      ? `${classes.card} ${classes.cardChecked}`
                      : classes.card
                  }`}
                  onClick={() => {
                    handleResetValues()
                    controlRadio('Cidadão')
                    setShowCitizenSelect(true)
                  }}
                >
                  <Box className={classes.cardHeader}>
                    <Box className={classes.radioInfo}>
                      <TbUser
                        className={`${
                          profile === 'Cidadão'
                            ? `${classes.icon} ${classes.iconChecked}`
                            : classes.icon
                        }`}
                        size={24}
                      />
                      <Box>
                        <Typography className={classes.title}>
                          Cidadão
                        </Typography>
                      </Box>
                    </Box>
                    <Radio
                      color="default"
                      checked={profile === 'Cidadão'}
                      onChange={() => {
                        handleResetValues()
                        controlRadio('Cidadão')
                        setShowCitizenSelect(true)
                      }}
                      value={profile}
                      name="radio-button"
                      classes={{ checked: classes.radioChecked }}
                    />
                  </Box>
                  {showCitizenSelect && profile === 'Cidadão' && (
                    <Box className={classes.containerSelectCitizen}>
                      <Typography className={classes.selectLabel}>
                        Selecione para quem será o agendamento
                      </Typography>
                      <FormControl fullWidth variant="outlined">
                        <Select
                          id="demo-controlled-open-select"
                          className={classes.select}
                          variant="outlined"
                          value={selectedValue}
                          onChange={handleSelectChange}
                          displayEmpty
                        >
                          <MenuItem value="para-mim">Para mim</MenuItem>
                          {!hasDependente &&
                            (loadingDependentes ? (
                              <MenuItem disabled>
                                <CircularProgress size={20} />
                              </MenuItem>
                            ) : (
                              dependentes.map((dep) => (
                                <MenuItem
                                  key={dep.id}
                                  value={dep.id.toString()}
                                >
                                  {dep.nome_completo}
                                </MenuItem>
                              ))
                            ))}
                        </Select>
                      </FormControl>
                      {hasDependente ? (
                        <Typography className={classes.registerDependentText}>
                          Este serviço não permite agendamento para dependentes.
                        </Typography>
                      ) : (
                        <Typography className={classes.registerDependentText}>
                          Não encontrou seu dependente?{' '}
                          <span
                            className={classes.clickableText}
                            onClick={(e) => {
                              e.stopPropagation()
                              setShowRegisterForm(true)
                              onRegisterFormVisibilityChange?.(true)
                            }}
                          >
                            Cadastre-o aqui.
                          </span>
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            )
          }
          if (list === 'Servidor') {
            return (
              <Box key={list} id="server-profile" className={classes.item}>
                <Box
                  className={`${
                    profile === 'Servidor'
                      ? `${classes.card} ${classes.cardChecked}`
                      : classes.card
                  }`}
                  onClick={() => {
                    handleResetValues()
                    controlRadio('Servidor')
                    setShowCitizenSelect(true)
                  }}
                >
                  <Box className={classes.cardHeader}>
                    <Box className={classes.radioInfo}>
                      <HiOutlineBriefcase
                        className={`${
                          profile === 'Servidor'
                            ? `${classes.icon} ${classes.iconChecked}`
                            : classes.icon
                        }`}
                        size={24}
                      />
                      <Box>
                        <Typography className={classes.title}>
                          Servidor
                        </Typography>
                      </Box>
                    </Box>
                    <Radio
                      color="default"
                      checked={profile === 'Servidor'}
                      onChange={() => {
                        handleResetValues()
                        controlRadio('Servidor')
                        setShowCitizenSelect(true)
                      }}
                      value={profile}
                      name="radio-button"
                      classes={{ checked: classes.radioChecked }}
                    />
                  </Box>
                  {showCitizenSelect && profile === 'Servidor' && (
                    <Box className={classes.containerSelectCitizen}>
                      <Typography className={classes.selectLabel}>
                        Selecione para quem será o agendamento
                      </Typography>
                      <FormControl fullWidth variant="outlined">
                        <Select
                          id="demo-controlled-open-select"
                          className={classes.select}
                          value={selectedValue}
                          onChange={handleSelectChange}
                          displayEmpty
                        >
                          <MenuItem value="para-mim">Para mim</MenuItem>
                          {!hasDependente &&
                            (loadingDependentes ? (
                              <MenuItem disabled>
                                <CircularProgress size={20} />
                              </MenuItem>
                            ) : (
                              dependentes.map((dep) => (
                                <MenuItem
                                  key={dep.id}
                                  value={dep.id.toString()}
                                >
                                  {dep.nome_completo}
                                </MenuItem>
                              ))
                            ))}
                        </Select>
                      </FormControl>
                      {hasDependente ? (
                        <Typography className={classes.registerDependentText}>
                          Este serviço não permite agendamento para dependentes.
                        </Typography>
                      ) : (
                        <Typography className={classes.registerDependentText}>
                          Não encontrou seu dependente?{' '}
                          <span
                            className={classes.clickableText}
                            onClick={(e) => {
                              e.stopPropagation()
                              setShowRegisterForm(true)
                              onRegisterFormVisibilityChange?.(true)
                            }}
                          >
                            Cadastre-o aqui.
                          </span>
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            )
          }
          if (list === 'Empresa') {
            return (
              <Box key={list} id="company-profile" className={classes.item}>
                <Box
                  className={`${
                    profile === 'Empresa'
                      ? `${classes.card} ${classes.cardChecked}`
                      : classes.card
                  }`}
                  onClick={() => {
                    controlRadio('Empresa')
                    setShowCitizenSelect(false)
                  }}
                >
                  <Box className={classes.cardHeader}>
                    <Box className={classes.radioInfo}>
                      <RiBuilding4Line
                        className={`${
                          profile === 'Empresa'
                            ? `${classes.icon} ${classes.iconChecked}`
                            : classes.icon
                        }`}
                        size={24}
                      />
                      <Box>
                        <Typography className={classes.title}>
                          Empresa
                        </Typography>
                      </Box>
                    </Box>
                    <Radio
                      color="default"
                      checked={profile === 'Empresa'}
                      onChange={() => controlRadio('Empresa')}
                      value="Empresa"
                      name="radio-button"
                      classes={{ checked: classes.radioChecked }}
                    />
                  </Box>
                  {profile === 'Empresa' && (
                    <Box className={classes.containerInfoEmployer}>
                      <FormControl fullWidth>
                        <TextField
                          id="cnpj-input"
                          label="Informe o CNPJ"
                          fullWidth
                          required
                          variant="outlined"
                          value={cnpjMask(cnpjNumber) || ''}
                          onChange={(value) => {
                            handleChangeValueCnpj(value)
                            handleResetValues()
                          }}
                          onBlur={getDataCompany}
                          inputProps={{
                            maxLength: 18,
                            style: { textTransform: 'uppercase' },
                          }}
                          error={Boolean(sefazError)}
                          helperText={sefazError || ''}
                        />
                      </FormControl>
                      {loading ? (
                        <div className={classes.containerLoading}>
                          <CircularProgress size={20} />
                        </div>
                      ) : (
                        <>
                          <FormControl fullWidth>
                            <TextField
                              id="social-input"
                              label="Razão Social"
                              fullWidth
                              required
                              variant="outlined"
                              disabled
                              value={companyName || ''}
                            />
                          </FormControl>
                          <FormControl fullWidth>
                            <TextField
                              id="cep-input"
                              label="Endereço com CEP"
                              fullWidth
                              required
                              disabled
                              value={companyAddress || ''}
                              variant="outlined"
                            />
                          </FormControl>
                        </>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            )
          }
          return ''
        })
      )}
      {!showRegisterForm && <AlertCard isVisible={isAlertVisible} />}
    </>
  )
}
